// import Vue from 'vue';
import { createI18n } from 'vue-i18n';
import messages from './messages';

const i18n = createI18n({
    locale: window.locale, // set locale
    allowComposition: true, // because of legacy mode.
    messages, // set locale messages
});

export default i18n;
